import { WebchatLog } from '@feedyou/utils'
import { Dictionary } from '@feedyou-ai/feedbot-schema'

import { VisibleLogCategory } from '../../store/dock/sections/try'

const visibleLogCategoryTypesByCategory: Dictionary<VisibleLogCategory, WebchatLog['type'][]> = {
  all: [],
  dialog: ['enterDialog', 'leaveDialog', 'endDialog'],
  storage: ['valueSet'],
  integration: ['httpRequest', 'httpResponse'],
  llm: ['chatResponsesRequest', 'chatResponsesResponse'],
  nlp: ['stepNlpResult', 'globalNlpResult', 'manualNlpResult'],
  switch: ['expression', 'case'],
  prompt: ['validationResult'],
  note: ['noteMessage', 'debugMessage'],
  other: ['action', 'email', 'attachment', 'preprocessorResult']
}

export function getAllVisibleLogCategories(): VisibleLogCategory[] {
  return Object.keys(visibleLogCategoryTypesByCategory) as VisibleLogCategory[]
}
